import EventOrganizersCard from './EventOrganizersCard'

export default EventOrganizersCard
